import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';
import {
  GET_HORSE_RACE_AUTHOR_COMMENTS,
  GET_HORSE_RACE_AUTHOR_COMMENTS_FAILURE,
  GET_HORSE_RACE_AUTHOR_COMMENTS_SUCCESS,
  GET_HORSE_RACE_AUTHOR_DETAILS,
  GET_HORSE_RACE_AUTHOR_DETAILS_FAILURE,
  GET_HORSE_RACE_AUTHOR_DETAILS_SUCCESS,
  GET_HORSE_RACE_AUTHORS,
  GET_HORSE_RACE_AUTHORS_FAILURE,
  GET_HORSE_RACE_AUTHORS_SUCCESS
} from 'Store/constants';
import { horseRacingCouponToBetslipMapper } from 'Utils/horseRacesNameMapper';
import { catchTJKError } from 'Utils/catchTJKError';
import { setHRBetslipFromCoupons } from 'Store/actions/horseRacing/betSlipActions';
import { openModal } from 'Store/actions';
import ProjectConfig from 'ProjectConfig';


export const getAuthors = () => async dispatch => {
  try {
    dispatch({
      type: GET_HORSE_RACE_AUTHORS,
    });

    const apiUrl = ProjectConfig.API_GATEWAY + '/mobile/tjk/author';
    const res = await axios.get(apiUrl);


    dispatch({
      type: GET_HORSE_RACE_AUTHORS_SUCCESS,
      payload: res.data.body.authors
    });

  } catch (e) {
    dispatch({
      type: GET_HORSE_RACE_AUTHORS_FAILURE,
      payload: (e.response && e.response.data) || errorMessage,
    });
  }
};

export const getAuthorDetails = slug => async dispatch => {
  try {
    dispatch({
      type: GET_HORSE_RACE_AUTHOR_DETAILS,
    });

    const apiUrl = ProjectConfig.API_GATEWAY + `/mobile/tjk/author/${slug}/comment`;
    const res = await axios.get(apiUrl);

    catchTJKError(res.data);
    dispatch({
      type: GET_HORSE_RACE_AUTHOR_DETAILS_SUCCESS,
      payload: res.data.body
    });

  } catch (e) {
    dispatch({
      type: GET_HORSE_RACE_AUTHOR_DETAILS_FAILURE,
      payload: (e.response && e.response.data) || errorMessage,
    });
  }
};

export const clearAuthorDetail = () => async dispatch => {
  dispatch({
    type: GET_HORSE_RACE_AUTHOR_DETAILS_SUCCESS,
    payload: {}
  });
};

export const getHRAuthorComments = requestPosition => async dispatch => {
  try {
    dispatch({
      type: GET_HORSE_RACE_AUTHOR_COMMENTS,
    });
    const params = { requestPosition };

    const apiUrl = ProjectConfig.API_GATEWAY + '/mobile/tjk/author/comment/v2';
    const res = await axios.get(apiUrl, { params });


    dispatch({
      type: GET_HORSE_RACE_AUTHOR_COMMENTS_SUCCESS,
      payload: res?.data?.body?.comments || []
    });

  } catch (e) {
    dispatch({
      type: GET_HORSE_RACE_AUTHOR_COMMENTS_FAILURE,
      payload: (e.response && e.response.data) || errorMessage,
    });
  }
};

export const getAuthorCommentsCoupon = (id, bet) => async dispatch => {
  try {

    const apiUrl = ProjectConfig.API_GATEWAY + `/mobile/tjk/coupon/instant/${id}`;
    const res = await axios.get(apiUrl);


    catchTJKError(res.data);

    const coupon = res?.data?.body?.coupon;
    const couponBet = bet ? { betTypeId: bet.betTypeId, selectableRace: bet.selectableRace, raceNumber: bet.raceNo, legSize: bet?.legSize, minSelectedHorseCount: bet.minSelectedHorseCount, betSlipBoxTitle: bet.betSlipTitle, boxTitle: bet.betSlipTitle  }
      : { betTypeId: coupon.betTypeId, selectableRace: coupon.selectableRace, raceNumber: coupon.raceNumber, legSize: coupon?.couponLegs?.length, minSelectedHorseCount: coupon.minSelectedHorseCount, betSlipBoxTitle: coupon.programPageLegTitle, boxTitle: coupon.betSlipTitle  };
    if (coupon?.raceStatus === 1 || (coupon?.raceStatus === 2 && coupon?.playableBets?.some(b=> b.betTypeId === bet?.betTypeId && b?.selectableRace === bet?.selectableRace))) {
      const newBetslip = horseRacingCouponToBetslipMapper(coupon,  couponBet);
      dispatch(setHRBetslipFromCoupons(newBetslip, couponBet, undefined, false));
    }


  } catch (e) {
    dispatch(openModal('tjkCouponPlayFailureModal'));
  }
};
